// extracted by mini-css-extract-plugin
export default {"alertAvButton":"uQ4tQnZD65GGtPwFibRR"};